import {
  Icon
} from 'ant-design-vue'

export default {
  install: function (Vue) {
    Vue.component('YxpIcon', Icon.createFromIconfontCN({
      scriptUrl: import('../../../assets/fonts/iconfont.js'), // 在 iconfont.cn 上生成
    }))
  }
}
